import { render, staticRenderFns } from "./ModalDuplicate.vue?vue&type=template&id=3707344a&"
import script from "./ModalDuplicate.vue?vue&type=script&lang=js&"
export * from "./ModalDuplicate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports